<script setup lang="ts">
defineProps<{ retryTestid?: string }>();
defineEmits<{ retry: [] }>();
const { t } = useI18n();
</script>

<template>
  <div class="py-8 flex flex-col items-center gap-y-4">
    <AppMessageWrapper type="error">
      <slot>{{ t("error.loading") }}</slot>
      <div class="my-1">
        <ULink as="button" class="text-current hover:text-current" :data-testid="retryTestid" @click="$emit('retry')">{{
          t("error.retry")
        }}</ULink>
      </div>
    </AppMessageWrapper>
  </div>
</template>
